import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appExchangeRateFlat]'
})
export class ExchangeRateFlatDirective {
  @Input() rate!: number;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit() {
    if (this.rate == 1) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
